import { AppConstantsConfig } from '@pf/shared-common';

export default {} as AppConstantsConfig;
